module.exports = __WEBPACK_EXTERNAL_MODULE_973__;


//////////////////
// WEBPACK FOOTER
// external "weaCube"
// module id = 973
// module chunks = 1